module.exports = __webpack_public_path__ + "img/case1.bec17116.png";